<template>
  <b-row>
    <b-col cols="12">
      <form-wizard-add />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FormWizardAdd from './FormWizardAdd.vue'

export default {
  components: {
    BRow,
    BCol,
    FormWizardAdd,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
